<template>
  <div>
    <div class="text-h5">Documentation</div>
    <hr />
    <div>
      The <b>Canvas Embed Tool</b> provides a way to add a link to the Canvas navigation bar.
      These links can be shown in <b>Account Navigation</b>, <b>Course Navigation</b>, and/or <b>User Navigation</b>.
      Clicking the link navigate to a new page in Canvas with an IFrame that displays the content of the <b>Embed URL</b> provided.

      <div class="text-h6 q-pt-md">Instructions</div>

      <ol>
        <li>
          Using the <b>Embed Tool Configuration Generator</b> on the left, input the <b>Embed Url</b> and
          select the <b>Location(s)</b> where the link should be displayed.
          <ul>
            <li>
              If you are embedding a <b>Canvas Page</b>, make sure you append <b>?embedded=true</b> to
              the url to prevent the Navigation bar from being displayed in the IFrame.
            </li>
            <li>
              The <b>Embed Url</b> must be a valid URL that can be embedded in an IFrame.  Some websites
              actively prevent this.
            </li>
          </ul>
        </li>
        <li>
          Clicking the <b>Generate</b> button will generate a link to the XML configuration.
        </li>
        <li>
          Open a new tab and navigate to the <b>Canvas Portal</b>.
        </li>
        <li>
          Click <b>Admin</b> -> <b>Developer Keys</b>.  Find the <b>Key</b> named <b>Wolf Embed Tool</b>.  You will need the <b>ID</b> and <b>Key</b>
          for the next step.
        </li>
        <li>
          Click <b>Admin</b> -> <b>Settings</b> -> <b>Apps</b> -> <b>View App Configurations</b> -> <b>+ App</b>.
          <ul>
            <li>
              If you want the link to be displayed for a specific Sub-Account, make sure you navigate to that
              Sub-Account before clicking Settings.
            </li>
          </ul>
        </li>
        <li>
          For Configuration Type, select <b>By URL</b>.  In the <b>Name</b> field, put the text you want displayed for the link.
          Paste the link generated in step 2 into the <b>Configuration URL</b> field.  Use the <b>ID</b> and <b>Key</b> from step 4.
        </li>
        <li>
          Click <b>Submit</b>.
        </li>
        <li>
          The link should now be displayed in the selected location(s).
        </li>
      </ol>

      <q-img
        src="@/assets/new_link.png"
        alt="Link Example"
        style="max-width: 195px;"
      />
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'

export default {
  name: 'config-documentation',
  components: {
  },

  setup () {
    const state = reactive({
      isLoading: false
    })

    return state
  }
}
</script>
